/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Normal_SaleInputs */

const vi_pos_normal_sale = /** @type {(inputs: Pos_Normal_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán thường`)
};

/**

* @param {Pos_Normal_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_normal_sale = /** @type {((inputs?: Pos_Normal_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Normal_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_normal_sale(inputs)
});